<div class="card">
  <div class="card-header">
    GCASH CSVs
  </div>

  <div class="table-responsive">
    <table class="align-middle table table-borderless table-striped table-hover">
      <thead>
      <tr>
        <th scope="col"></th>
        <th>Generated by</th>
        <th>Period</th>
        <th>File</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let file of files | async | paginate: {itemsPerPage: 10, currentPage: p}">
        <th scope="row">
          <a class="mr-2" (click)="download(file.id)">
            <img src="assets/img/download.svg" tooltip="Download"></a>
        </th>
        <td>{{file.account_name}}</td>
        <td>{{file.period}}</td>
        <td>{{file.filename}}</td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="d-block card-footer">
    <pagination-controls (pageChange)="p = $event"></pagination-controls>
  </div>
</div>
